import styled from 'styled-components';

const Title = styled.h1`
  color: #000;
  font-size: 30px;
  line-height: 35px;
`;

export default Title;
